import React, {useState, useEffect} from 'react'

const CatalogueFilterSliderInput = ({value, className, minValue, maxValue, setPrice}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value)
  }, [value]);

  const validateInputValue = value => {
    if (value < minValue) {
      return minValue;
    } else if (value > maxValue) {
      return maxValue;
    }
    return value;
  };

  const handleInputChange = event => {
    const newValue = parseInt(event.target.value);

    setInputValue(newValue);
  };

  const handleInputBlur = () => {
    setInputValue(validateInputValue(inputValue));
    setPrice(validateInputValue(inputValue));
  };

  const handleInputKeyPress = event => {
    if (event.key === 'Enter') {
      setInputValue(validateInputValue(inputValue));
      setPrice(validateInputValue(inputValue));
    }
  };

  return (
    <input type="text"
           className={className}
           value={inputValue}
           onChange={handleInputChange}
           onBlur={handleInputBlur}
           onKeyPress={handleInputKeyPress}
    />
  )
};

export default CatalogueFilterSliderInput
